import React from 'react'
import { User, Mail, Twitter, Linkedin, Facebook } from 'lucide-react'

const AuthorCard = ({ post }) => {
  // Author data based on category
  const authors = {
    'production-update': {
      name: 'Kamal Hossain',
      role: 'Director & Founder',
      bio: 'Award-winning filmmaker with over 15 years of experience in Bangladeshi cinema. Passionate about telling authentic cultural stories.',
      image: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=400',
      email: 'kamal@shikdarfilms.com',
      social: {
        twitter: '#',
        linkedin: '#',
        facebook: '#'
      }
    },
    'filmmaking-insight': {
      name: 'Tanvir Ahmed',
      role: 'Director of Photography',
      bio: 'Master cinematographer specializing in visual storytelling. Known for capturing the essence of Bengali culture through lens.',
      image: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=400',
      email: 'tanvir@shikdarfilms.com',
      social: {
        twitter: '#',
        linkedin: '#',
        facebook: '#'
      }
    },
    'industry': {
      name: 'Sadia Rahman',
      role: 'Producer',
      bio: 'Experienced producer with expertise in managing complex film productions and industry insights.',
      image: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=400',
      email: 'sadia@shikdarfilms.com',
      social: {
        twitter: '#',
        linkedin: '#',
        facebook: '#'
      }
    }
  }

  // Default author if category not found
  const author = authors[post.category] || authors['production-update']

  const handleImageError = (e) => {
    e.target.src = 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400'
  }

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 border-l-4 border-bengal-green" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="1:1" data-component-id="client/src/components/AuthorCard.jsx:1:1">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="2:2" data-component-id="client/src/components/AuthorCard.jsx:2:2">About the Author</h3>
      
      <div className="flex flex-col md:flex-row gap-6" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="4:2" data-component-id="client/src/components/AuthorCard.jsx:4:2">
        {/* Author Image */}
        <div className="flex-shrink-0" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="6:3" data-component-id="client/src/components/AuthorCard.jsx:6:3">
          <img 
            src={author.image}
            alt={author.name}
            onError={handleImageError}
            className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
            data-component-path="client/src/components/AuthorCard.jsx" data-component-line="7:4" data-component-id="client/src/components/AuthorCard.jsx:7:4"
          />
        </div>

        {/* Author Info */}
        <div className="flex-1" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="16:3" data-component-id="client/src/components/AuthorCard.jsx:16:3">
          <h4 className="text-2xl font-bold text-gray-900 mb-1 section-title" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="17:4" data-component-id="client/src/components/AuthorCard.jsx:17:4">
            {author.name}
          </h4>
          <p className="text-bengal-orange font-semibold mb-3" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="20:4" data-component-id="client/src/components/AuthorCard.jsx:20:4">{author.role}</p>
          <p className="text-gray-700 leading-relaxed mb-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="21:4" data-component-id="client/src/components/AuthorCard.jsx:21:4">
            {author.bio}
          </p>

          {/* Contact & Social */}
          <div className="flex flex-wrap items-center gap-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="26:4" data-component-id="client/src/components/AuthorCard.jsx:26:4">
            <a 
              href={`mailto:${author.email}`}
              className="inline-flex items-center gap-2 text-gray-600 hover:text-bengal-green transition-colors"
              data-component-path="client/src/components/AuthorCard.jsx" data-component-line="27:5" data-component-id="client/src/components/AuthorCard.jsx:27:5"
            >
              <Mail className="w-4 h-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="31:6" data-component-id="client/src/components/AuthorCard.jsx:31:6" />
              <span className="text-sm" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="32:6" data-component-id="client/src/components/AuthorCard.jsx:32:6">{author.email}</span>
            </a>

            <div className="flex items-center gap-3 ml-auto" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="35:5" data-component-id="client/src/components/AuthorCard.jsx:35:5">
              <a 
                href={author.social.twitter}
                className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-blue-400 hover:shadow-md transition-all"
                data-component-path="client/src/components/AuthorCard.jsx" data-component-line="36:6" data-component-id="client/src/components/AuthorCard.jsx:36:6"
              >
                <Twitter className="w-4 h-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="40:7" data-component-id="client/src/components/AuthorCard.jsx:40:7" />
              </a>
              <a 
                href={author.social.linkedin}
                className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-blue-600 hover:shadow-md transition-all"
                data-component-path="client/src/components/AuthorCard.jsx" data-component-line="42:6" data-component-id="client/src/components/AuthorCard.jsx:42:6"
              >
                <Linkedin className="w-4 h-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="46:7" data-component-id="client/src/components/AuthorCard.jsx:46:7" />
              </a>
              <a 
                href={author.social.facebook}
                className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-blue-700 hover:shadow-md transition-all"
                data-component-path="client/src/components/AuthorCard.jsx" data-component-line="48:6" data-component-id="client/src/components/AuthorCard.jsx:48:6"
              >
                <Facebook className="w-4 h-4" data-component-path="client/src/components/AuthorCard.jsx" data-component-line="52:7" data-component-id="client/src/components/AuthorCard.jsx:52:7" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthorCard